import { translateProductName } from "./translateProductName";

    // Utility function to format product data for components
export const formatProductForSlideshow = (product) => {
    return {
        id: product.id,
        srcImage: product.image || '',
        textType: "name",
        productText: translateProductName(product.name),
        price: product.price,
        slug: product.slug,
        description: product.short_description || product.description,
        regular_price: product.regular_price,
        sale_price: product.sale_price,
        on_sale: product.on_sale
    };
};

// Utility function to format category data
export const formatCategoryData = (category) => {
    return {
        id: category.id,
        name: category.name,
        slug: category.slug,
        description: category.description,
        image: category.image?.src || '',
        count: category.count,
        products: category.products?.map(formatProductForSlideshow) || []
    };
};

// Format price with currency
export const formatPrice = (price, currency = 'VND') => {
    if (!price) return '';

    // Convert price to number and format with thousand separators
    const numPrice = parseFloat(price);
    return `${numPrice.toLocaleString()} ${currency}`;
};

// Filter categories that have products
export const filterCategoriesWithProducts = (categories) => {

    return categories.filter(category =>
        category?.products &&
        category?.products?.length > 0
    );
};
